<template>
  <div>
    <loading v-if="loading" />
    <div v-if="isAuthenticated">
      <p>
        Вы авторизованы и находитесь на главной странице.
      </p>
    </div>
    <div v-if="!isAuthenticated && authStatus !== 'loading'">
      <h1>Личный кабинет Lokeo.ru</h1>
      <login />
    </div>
  </div>
</template>

<style>
.home {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>

<script>
import { mapGetters } from "vuex";
import Login from "components/user/Login";

export default {
  components: {
    Login
  },
  name: "home",
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    }
  },
  data() {
    return {};
  }
};
</script>
